import {
    ArticleOutlined,
    CheckCircleOutline,
    UploadFile,
} from '@mui/icons-material';
import {
    Container,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Box,
    Grid,
    Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PrimaryButton from 'components/buttons/PrimaryButton';
import SecondaryButton from 'components/buttons/SecondaryButton';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from 'utils/axios';
import FormatDate from 'utils/formatDate';
import isValidDate from 'utils/isValidDate';

const AbstractsSubmissionPage = () => {
    const [endPeriod, setEndPeriod] = useState();
    const [disableButtonSumit, setDisableButtonSubmit] = useState(false);
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const getData = async () => {
        await axiosInstance
            .get('api/system-parameters/name/end_off_submission_period')
            .then(({ data }) => {
                setEndPeriod(FormatDate(data.value, 'MMMM do, yyyy HH:mm'));
                setDisableButtonSubmit(!isValidDate(data.value));
            })
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        getData();
    }, []);

    return (
        <Container>
            {disableButtonSumit && (
                <Typography
                    align="center"
                    variant="h5"
                    sx={{
                        fontWeight: 700,
                        color: 'red',
                        textTransform: 'uppercase',
                    }}
                >
                    Abstract submission is now closed, <br /> thank you for your
                    submissions.
                </Typography>
            )}

            <Box
                width={1}
                height={1}
                data-aos={'fade-up'}
                data-aos-delay={100}
                data-aos-offset={100}
                data-aos-duration={600}
            >
                <Typography
                    variant="h5"
                    color="text.primary"
                    align={'left'}
                    gutterBottom
                    sx={{
                        fontWeight: 500,
                        marginBottom: 2,
                    }}
                >
                    General Information
                </Typography>
                <Typography marginTop={2} textAlign={'justify'}>
                    Abstract submission is free of charge and must be completed
                    online only via the InaAcc website Abstract Submission
                    platform www.inaacc.or.id .Abstracts sent by email will not
                    be accepted. Your abstract will be automatically corrected
                    and edited according to InaAcc website submission format.
                    Its authors responsibility to review the submissions and
                    correct them.
                </Typography>

                <Typography
                    variant="h5"
                    color="text.primary"
                    align={'left'}
                    gutterBottom
                    sx={{
                        fontWeight: 500,
                        marginTop: 3,
                    }}
                >
                    Case Report, Original Research, and Meta Analysis
                </Typography>

                <List>
                    <ListItem>
                        <ListItemIcon>
                            <CheckCircleOutline />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                'All Case and Research Abstracts must be submitted and received before ' +
                                endPeriod
                            }
                        />
                    </ListItem>
                </List>

                <Typography marginTop={1}>
                    <b>
                        Note : Corresponding author must be registered as a
                        participant of INAACC Semarang 2026. Abstracts must be
                        submitted using the online abstract form. Paper, faxed
                        or emailed submissions will be rejected.
                    </b>
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', my: 4, justifyContent: 'center' }}>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    sx={{
                        display: 'flex',
                        gap: 3,
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Box marginBottom={isMd ? 0 : 2}>
                        <Link to={disableButtonSumit ? '#' : '/signin'}>
                            <PrimaryButton
                                disabled={disableButtonSumit}
                                startIcon={<UploadFile />}
                                component={'a'}
                                variant="contained"
                                color="primary"
                                size="large"
                                fullWidth={isMd ? false : true}
                            >
                                {disableButtonSumit
                                    ? 'Submission Close'
                                    : 'Submit Now'}
                            </PrimaryButton>
                        </Link>
                    </Box>
                    <Box>
                        <Link
                            to="/assets/Abstract Guideline InaACC 2026.pdf"
                            target="_blank"
                            download
                        >
                            <SecondaryButton
                                size="large"
                                startIcon={<ArticleOutlined />}
                                variant="outlined"
                            >
                                Abstract Submission Guidelines
                            </SecondaryButton>
                        </Link>
                    </Box>
                </Grid>
            </Box>
        </Container>
    );
};

export default AbstractsSubmissionPage;
